import { TypeChecker } from '@attain-apps/type-guards'

import { type AllInstances, getAllHelpers } from './all'

// NOTE: more performant
export type Instance<T = any> = Partial<AllInstances<T>>
// NOTE: more correct
// export type Instance<T = any> = ExactlyOneOf<InstanceAll<T>>
export namespace Instance {
  export const isInstance: TypeChecker<Instance> = TypeChecker.Factory.lazy(
    () =>
      TypeChecker.Factory.union(
        ...getAllHelpers().map(helper => helper.typeChecker),
      ),
  ).usingAlias('Instance')
}
